export default "__VITE_ASSET__4483c52d__"